// extracted by mini-css-extract-plugin
export default {"checkbox":"Login_checkbox__+-Ro5"};